/* Hand-rolled inline SVG social icons.
 * Inline SVG (no external icon library) so the production bundle can never
 * tree-shake or fail to render the glyphs — the most common cause of "icons
 * missing on prod but visible in dev". */

export const FacebookIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M13.5 22v-8h2.7l.4-3.2H13.5V8.7c0-.9.3-1.6 1.6-1.6h1.7V4.2c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.1v2.5H7.7V14h2.7v8h3.1z" />
  </svg>
);

export const InstagramIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.3" cy="6.7" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const PinterestIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="9.5" />
    <path d="M9.4 21l3-12" />
    <path d="M9.5 14.5c.5 1.4 1.7 2 3 2 2.6 0 4.7-2.3 4.7-5.4 0-3-2.4-5.5-5.8-5.5C7.5 5.6 5 8.3 5 11.5c0 1.7.7 3 2 3.5" />
  </svg>
);

const LINKS = [
  { href: process.env.REACT_APP_FACEBOOK_URL  || "https://www.facebook.com/VoraStyle512/",   label: "Facebook",  Icon: FacebookIcon,  testid: "social-facebook" },
  { href: process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/vorastyle512",   label: "Instagram", Icon: InstagramIcon, testid: "social-instagram" },
  { href: process.env.REACT_APP_PINTEREST_URL || "https://www.pinterest.com/vorastyle",      label: "Pinterest", Icon: PinterestIcon, testid: "social-pinterest" },
];

/**
 * Compact horizontal row of social media links.
 * Used in the navbar (top-right) and footer.
 */
export default function SocialIcons({
  size = "sm",
  variant = "ghost",
  className = "",
  testidPrefix = "",
  urls = null,
}) {
  const sizeClasses = size === "lg" ? "w-9 h-9" : size === "md" ? "w-8 h-8" : "w-7 h-7";
  const iconClass = size === "lg" ? "w-4 h-4" : size === "md" ? "w-[14px] h-[14px]" : "w-[13px] h-[13px]";
  const base =
    variant === "boxed"
      ? "border border-[#E5E5E5] hover:border-[#9CA47E]"
      : "hover:bg-[#F2EDE3]";
  // Allow caller to override the env-defaulted URLs (used by Footer to surface
  // admin-editable settings). Falls back to LINKS defaults if a URL is empty.
  const resolved = urls
    ? [
        { ...LINKS[0], href: urls.facebook  || LINKS[0].href },
        { ...LINKS[1], href: urls.instagram || LINKS[1].href },
        { ...LINKS[2], href: urls.pinterest || LINKS[2].href },
      ]
    : LINKS;
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid={`${testidPrefix}social-icons`}>
      {resolved.map(({ href, label, Icon, testid }) => (
        <a
          key={testid}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`VoraStyle on ${label}`}
          data-testid={`${testidPrefix}${testid}`}
          className={`${sizeClasses} inline-flex items-center justify-center text-[#595959] hover:text-[#9CA47E] transition-colors ${base}`}
        >
          <Icon className={iconClass} />
        </a>
      ))}
    </div>
  );
}
